export function dashboardPendingEventsReviewItemTemplate($templateCache) {
    'ngInject';

    // Insert a mounting point for the dashboard into the template cache.
    // This is configured in the database as a file path, for compatibility
    // with the other generic dashboards.
    const path = "dashboard-pending-events-review-item-template.html";
    const html = `<apex-dashboard-pending-events-review-container></apex-dashboard-pending-events-review-container>`;
    $templateCache.put(path, html);
}

export function dashboardPendingEventsReviewListItemTemplate($templateCache) {
    'ngInject';

    // Display summary data in the list item section.
    const path = "dashboard-pending-events-review-list-item-template.html";
    const html = `
        <p ng-if="dashboard.count === 0">No pending schedule events assigned</p>
        <p ng-if="dashboard.count > 0">Pending schedule events can be approved or rejected</p>`;
    $templateCache.put(path, html);
}
